module.exports = __webpack_public_path__ + "static/img/图片 63.b895c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/图片 63.png
// module id = GVqU
// module chunks = 1